module.exports = __webpack_public_path__ + "static/media/CDC-EN-notices-P4.dfa8508c.jpg";